// 商机状态
export const BUSINESS_STATUS_VALUE = {
  DONE: 3,
  ING: 2,
  CLOSE: 4,
  FOLLOW: 1,
}
export const BUSINESS_STATUS = [
  {
    label: '待跟进',
    value: BUSINESS_STATUS_VALUE.FOLLOW,
  },
  {
    label: '跟进中',
    value: BUSINESS_STATUS_VALUE.ING,
  },
  {
    label: '已完成',
    value: BUSINESS_STATUS_VALUE.DONE,
  },
  {
    label: '已关闭',
    value: BUSINESS_STATUS_VALUE.CLOSE,
  },
]
